import Syam_Yadavalli from "../../../images/TechTeam/Syam_Yadavalli.jpg";
import Harsh_Ranjan_Sinha from "../../../images/TechTeam/Harsh_Ranjan_Sinha.jpg";
import Shazma_Siddiqui from "../../../images/TechTeam/Shazma_Siddiqui.jpg";
import Aniket_Kumar from "../../../images/TechTeam/Aniket_Kumar.jpg";
import Rahul_Singh from "../../../images/TechTeam/Rahul_Singh.jpg";
import Vibhuti_Chandrakar from "../../../images/TechTeam/Vibhuti_Chandrakar.jpg";
import Piyush_Kumar from "../../../images/TechTeam/Piyush_Kumar.jpg";
import Somil_Puri from "../../../images/TechTeam/Somil_Puri.jpg";
import Ankit_Kumar_Lakra from "../../../images/TechTeam/Ankit_Kumar_Lakra.jpg";

import Rishav_Gandhi from "../../../images/TechTeam/rishav-gandhi.jpeg";
import D_Anuj from "../../../images/TechTeam/d_anuj.jpg";

import Premchand_Maddikuntla from '../../../images/TechTeam/Premchand_Maddikuntla.jpg'


export const techteamList = [
  {
    id: 1,
    name: "Syam Yadavalli",
    imgUrl: Syam_Yadavalli,
    linkedinUrl: "https://www.linkedin.com/in/syam-yadavalli",
    instaUrl: "#",
    desi: "Head Coordinator"
  },
  {
    id: 2,
    name: "Shazma Siddiqui",
    imgUrl: Shazma_Siddiqui,
    linkedinUrl: "https://www.linkedin.com/in/shazmasiddiqui",
    instaUrl: "#",
    desi: "Core Coordinator"
  },
  {
    id: 3,
    name: "Rishav Gandhi",
    imgUrl: Rishav_Gandhi,
    linkedinUrl: "https://www.linkedin.com/in/rishav-gandhi-998a74211",
    instaUrl: "#",
    desi: "Core Coordinator"
  },
  {
    id: 4,
    name: "Harsh Ranjan Sinha",
    imgUrl: Harsh_Ranjan_Sinha,
    linkedinUrl: "https://www.linkedin.com/in/sinha-harsh",
    instaUrl: "#",
    desi: "Core Coordinator"
  },

  {
    id: 5,
    name: "Premchand Maddikuntla",
    imgUrl: Premchand_Maddikuntla,
    linkedinUrl: "https://www.linkedin.com/in/prem913",
    instaUrl: "#",
    desi: "Core Coordinator"
  },
  {
    id: 6,
    name: "Aniket Kumar",
    imgUrl: Aniket_Kumar,
    linkedinUrl: "https://www.linkedin.com/in/kraniket901",
    instaUrl: "#",
    desi: "Executive"
  },
  {
    id: 7,
    name: "Rahul Singh",
    imgUrl: Rahul_Singh,
    linkedinUrl: "https://www.linkedin.com/in/rahulsingh19390",
    instaUrl: "#",
    desi:"Executive"
  },
  {
    id: 8,
    name: "Vibhuti Chandrakar",
    imgUrl: Vibhuti_Chandrakar,
    linkedinUrl: "https://www.linkedin.com/in/vibhuti-chandrakar-4b1bb024b",
    instaUrl: "#",
    desi: "Executive"
  },
  {
    id: 9,
    name: "Piyush Kumar",
    imgUrl: Piyush_Kumar,
    linkedinUrl: "https://www.linkedin.com/in/piyush-in",
    instaUrl: "#",
    desi: "Executive"
  },
  {
    id: 10,
    name: "Anuj Singh",
    imgUrl: D_Anuj,
    linkedinUrl: "https://www.linkedin.com/in/d-anuj-kumar",
    instaUrl: "#",
    desi: "Executive"
  },
  {
    id: 11,
    name: "Somil Puri",
    imgUrl: Somil_Puri,
    linkedinUrl: "https://www.linkedin.com/in/somil-puri-0b392a231",
    instaUrl: "#",
    desi: "Executive"
  },
  {
    id: 12,
    name: "Ankit Kumar Lakra",
    imgUrl: Ankit_Kumar_Lakra,
    linkedinUrl: "https://www.linkedin.com/in/ankitklakra/",
    instaUrl: "#",
    desi: "Executive"
  },

];
